/**
 * Reference: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 *
 * || Pattern field length   |  Typical style, alphanumeric item  | Typical style, alpha-only item  ||
 * || --------------------------------------------------------------------------------------------- ||
 * ||  1	                   |  Numeric, 1-2 digits (e.g. M)      |                                 ||
 * ||  2	                   |  Numeric, 2 digits (e.g. MM)       | Abbreviated (e.g. E, EE, EEE)   ||
 * ||  3	                   |  Abbreviated (e.g. MMM)            |________________________________ ||
 * ||  4                     |  Wide / Long / Full e.g. MMMM, EEEE|________________________________ ||
 * ||  5                     |	Narrow (e.g. MMMMM, EEEEE) - The counter-intuitive use of 5 letters ||
 * ||                        |  for this is forced by backwards compatibility                       ||
 * || _____________________________________________________________________________________________ ||
 *
 * Example time string: YYYY-MM-DDTHH:mm:ss.sssZ
 * - YYYY: year
 * - MM: month (1 to 12)
 * - DD: date (1 to 31)
 * - h: hour in 12-hour format
 * - hh: hour in 12-hour format with zero padding
 * - H: hour in 24-hour format (0 to 23)
 * - HH: hour in 24-hour format (0 to 23) with zero padding
 * - m: minutes (0 to 59)
 * - mm: minutes (0 to 59) with zero padding
 * - ss: seconds (00 to 59)
 * - sss: milliseconds (0 to 999)
 * - T: separate the date and time in the string
 * - z:	short timezone (i.e. PDT)
 * - zzzz: long timezone (i.e. Pacific Daylight Time)
 * - Z: UTC time format
 *
 */
const placeholderMap = {
    day: "D",
    dayPeriod: "AM",
    era: "AD",
    fractionalSecond: "s",
    hour: "h",
    minute: "m",
    month: "M",
    second: "s",
    timeZoneName: "Z",
    year: "Y",
};
export { placeholderMap };
